import AbstractProduction from '@/roc/effects/Production/AbstractProduction';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import Happiness from "@/roc/effects/CultureBonus/Happiness";
class Effects {
    __effects;
    constructor(effects) {
        this.__effects = effects;
    }
    static create(effects) {
        return new Effects(effects);
    }
    static asEmpty() {
        return new Effects([]);
    }
    count() {
        return this.__effects.length;
    }
    isProduction(index) {
        return this.__effects[index] instanceof AbstractProduction;
    }
    isBonus(index) {
        return this.__effects[index] instanceof PassiveAura || this.__effects[index] instanceof CultureBonus;
    }
    providesCulture() {
        for (let i = 0; i < this.__effects.length; i++) {
            if (this.__effects[i] instanceof CultureBonus) {
                return true;
            }
        }
        return false;
    }
    getCulture(level, era) {
        for (let i = 0; i < this.__effects.length; i++) {
            const eff = this.__effects[i];
            if (eff instanceof CultureBonus) {
                return eff.getBonus(level, era);
            }
        }
        return null;
    }
    getHappiness() {
        for (let i = 0; i < this.__effects.length; i++) {
            const effect = this.__effects[i];
            if (effect instanceof Happiness) {
                return effect;
            }
        }
        return null;
    }
    getDescription(index, era, level) {
        const effect = this.__effects[index] || null;
        if (!effect) {
            return null;
        }
        return effect.formatDescription(level, era);
    }
    getEffect(index) {
        return this.__effects[index];
    }
}
export default Effects;
